<script lang="ts" setup>
import { computed, onMounted, watch } from 'vue';
import { useAuthStore, useTenantStore } from '@/store';
import { useIdle } from '@vueuse/core';

const { idle } = useIdle(Number(process.env.VUE_APP_TIMEOUT));
const authStore = useAuthStore();
const tenantStore = useTenantStore();

/**
 * on mounted (refreshed) go get any access tokens in storage
 */
onMounted(() => init());

const init = async () => {
  await authStore.fetchAccessToken();
  await authStore.boot();
  document.body.classList.add('theme');
};

const isLoading = computed(() => authStore.loading);

/**
 * if idle for longer than 20 minutes then log them out
 */
const handleIdleValue = async (val: boolean) => {
  /**
   * if existing tenant is a guest tenant then leave it
   * if impersonating in that tenant be sure to leave that first
   */
  if (authStore.isImpersonating) {
    await authStore.leaveImpersonate(true);
  }
  if (authStore.isSwitchTenant) {
    const { guest_tenant } = authStore.impersonateTenantToken;
    await tenantStore.leaveTenant(guest_tenant.id);
    authStore.impersonateTenantToken = null;
  }
  if (val) authStore.stopLogin();
};

watch(idle, handleIdleValue);
</script>

<template>
  <head></head>
  <div class="container">
    <BaseLayout v-if="!isLoading">
      <Toast position="top-right" />
      <RouterView />
    </BaseLayout>
  </div>
</template>

<style lang="scss">
// eslint-disable-next-line vue/block-tag-newline
@import './theme/tms/theme.scss';
</style>
